import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { formatINR } from "@/lib/api";

// Edit Order dialog — PENDING orders only: quantity, stone weight, and labour/making charge. Pricing recalculated server-side on save.
export const EditOrderItemsDialog = ({ editItemsFor, onClose, editItemsDraft, updateDraftField, draftEstimatedTotal, busy, onSubmit }) => (
  <Dialog open={!!editItemsFor} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="edit-order-dialog" className="max-w-2xl max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Edit Order — {editItemsFor?.order_no}</DialogTitle>
        <DialogDescription>Adjust quantity, stone weight, and labour/making charges before this order is approved. Pricing is recalculated on save.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        {editItemsDraft.map((d) => (
          <div key={d.product_id} data-testid="edit-order-item-row" className="rounded-lg border border-border p-3 space-y-3">
            <div className="flex items-center justify-between">
              <div className="min-w-0">
                <div className="font-medium truncate">{d.name}</div>
                <div className="text-xs text-muted-foreground font-mono">{d.sku}</div>
              </div>
              <span className="text-xs text-muted-foreground font-mono">Current: {formatINR(d.current_line_total)}</span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              <div>
                <Label className="text-xs">Quantity</Label>
                <Input data-testid="edit-order-item-quantity" type="number" min={1} value={d.quantity}
                  onChange={(e) => updateDraftField(d.product_id, "quantity", e.target.value)} className="mt-1 font-mono" />
              </div>
              {d.has_diamonds && (
                <div>
                  <Label className="text-xs">Diamond Weight (ct)</Label>
                  <Input data-testid="edit-order-item-diamond-carat" type="number" step="0.01" min={0} value={d.diamond_carat_total}
                    onChange={(e) => updateDraftField(d.product_id, "diamond_carat_total", e.target.value)} className="mt-1 font-mono" />
                </div>
              )}
              {d.has_stones && (
                <div>
                  <Label className="text-xs">Colour Stone Weight (ct)</Label>
                  <Input data-testid="edit-order-item-stone-carat" type="number" step="0.01" min={0} value={d.stone_carat_total}
                    onChange={(e) => updateDraftField(d.product_id, "stone_carat_total", e.target.value)} className="mt-1 font-mono" />
                </div>
              )}
              {d.has_gold && (
                <div>
                  <Label className="text-xs">Labour / Making (₹)</Label>
                  <Input data-testid="edit-order-item-making-value" type="number" step="1" min={0} value={d.making_value}
                    onChange={(e) => updateDraftField(d.product_id, "making_value", e.target.value)} className="mt-1 font-mono" />
                </div>
              )}
            </div>
          </div>
        ))}
        <div className="flex items-center justify-between px-1 text-sm text-muted-foreground">
          <span>Current order total (before edits)</span>
          <span data-testid="edit-order-current-total" className="font-mono">{formatINR(draftEstimatedTotal)}</span>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button data-testid="edit-order-submit" disabled={busy} onClick={onSubmit}>Save & Recalculate</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
